import { EventBus } from "../eventbus";
import i18n from "./i18next";

export const errorDispatch = (errorText) => {
  EventBus.$emit(`snackbar--add`, {
    title: i18n.t(`error.${errorText}`),
    icon: "error--round",
    color: "#df3535",
  });
};
